/**
 * Helpers for vehicle pickup/drop location hub points.
 */

export const extractLocationIdsFromPoints = (points) => {
  if (!Array.isArray(points)) return [];
  return points
    .map((point) => {
      if (typeof point === 'number') return point;
      if (point && typeof point === 'object') return point.location_id;
      return null;
    })
    .filter((id) => id != null);
};

export const buildLocationPointsPayload = (locationIds, locations) => {
  return locationIds.map((locationId) => {
    const hub = locations.find(
      (loc) => loc.id === locationId || String(loc.id) === String(locationId)
    );
    return {
      location_id: Number(locationId),
      destination: hub?.location || hub?.hub_name || hub?.name || '',
    };
  });
};

export const formatLocationPointsSummary = (points, fallback = '—') => {
  if (!Array.isArray(points) || points.length === 0) return fallback;
  const labels = points
    .map((point) => {
      if (typeof point === 'string') return point;
      return point?.destination || point?.location || null;
    })
    .filter(Boolean);
  return labels.length > 0 ? labels.join(', ') : fallback;
};

/**
 * Returns { first, extraCount, labels } for compact list-page display:
 * first location name + "+N" for the rest, plus the full label array for a modal/tooltip.
 */
export const formatLocationPointsDisplay = (points, fallback = '—') => {
  const labels = (Array.isArray(points) ? points : [])
    .map((point) => {
      if (typeof point === 'string') return point;
      return point?.destination || point?.location || null;
    })
    .filter(Boolean);

  if (labels.length === 0) {
    return { first: fallback, extraCount: 0, labels: [] };
  }

  return {
    first: labels[0],
    extraCount: labels.length - 1,
    labels,
  };
};

export const validateLocationPointSelection = () => {
  // A location can be both a pickup and a drop point (vehicles can run the
  // reverse route), so no overlap restriction is enforced.
  return '';
};
